import { Helmet } from "react-helmet-async";
import SEO_CONFIG from "./seoConfig";

export default function SEO({

    title = SEO_CONFIG.defaultTitle,

    description = SEO_CONFIG.defaultDescription,

    keywords = "",

    image = SEO_CONFIG.defaultImage,

    url = SEO_CONFIG.siteUrl,

    noIndex = false,

}) {

    return (

        <Helmet>

            <title>{title}</title>

            <meta
                name="description"
                content={description}
            />

            {keywords && (
                <meta
                    name="keywords"
                    content={keywords}
                />
            )}

            <meta
                name="theme-color"
                content={SEO_CONFIG.themeColor}
            />

            <meta
                name="robots"
                content={noIndex ? "noindex,nofollow" : "index,follow"}
            />

            <link
                rel="canonical"
                href={url}
            />

            {/* Open Graph */}

            <meta property="og:type" content="website" />

            <meta property="og:site_name" content={SEO_CONFIG.siteName} />

            <meta property="og:title" content={title} />

            <meta property="og:description" content={description} />

            <meta property="og:image" content={image} />

            <meta property="og:url" content={url} />

            {/* Twitter */}

            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <meta
                name="twitter:title"
                content={title}
            />

            <meta
                name="twitter:description"
                content={description}
            />

            <meta
                name="twitter:image"
                content={image}
            />

        </Helmet>

    );
}